import { Configuration, PopupRequest } from "@azure/msal-browser";

/**
 * Configuration object to be passed to MSAL instance on creation. 
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md 
 */
const getRedirectUri = () => {
    if (Capacitor.isNativePlatform()) {
        return "klydapp://auth";
    }
    return import.meta.env.DEV ? "http://localhost:5173" : "https://k-lydapp.ldconstructora.cl";
};

export const msalConfig: Configuration = {
    auth: {
        // 'clientId' es el Application (client) ID de tu registro en Azure AD
        clientId: import.meta.env.VITE_AZURE_CLIENT_ID || "TU_CLIENT_ID_AQUI",

        // 'authority' es el endpoint para Single Tenant usando tu Tenant ID
        authority: `https://login.microsoftonline.com/${import.meta.env.VITE_AZURE_TENANT_ID || "TU_TENANT_ID_AQUI"}`,

        // La URL a la que redirige luego del login
        redirectUri: getRedirectUri(),

        // La URL a la que redirige luego del logout
        postLogoutRedirectUri: getRedirectUri()
    },
    cache: {
        cacheLocation: "localStorage" // This configures where your cache will be stored
    }
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit: 
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest: PopupRequest = {
    scopes: ["User.Read"]
};

import { NavigationClient, NavigationOptions } from "@azure/msal-browser";
import { Browser } from "@capacitor/browser";
import { Capacitor } from "@capacitor/core";

/**
 * Custom Navigation Client for MSAL.
 * When running in Capacitor, it uses the In-App Browser to open the login page
 * instead of replacing the entire WebView, preventing the user from getting stuck
 * in the system browser.
 */
export const clearMsalCacheForce = () => {
    console.warn("[MSAL Mobile] Forzando limpieza de caché y estado de interacción de MSAL.");
    try {
        for (let i = 0; i < localStorage.length; i++) {
            const key = localStorage.key(i);
            if (key && (key.startsWith("msal.") || key.includes("msal"))) {
                localStorage.removeItem(key);
            }
        }
        for (let i = 0; i < sessionStorage.length; i++) {
            const key = sessionStorage.key(i);
            if (key && (key.startsWith("msal.") || key.includes("msal"))) {
                sessionStorage.removeItem(key);
            }
        }
    } catch (e) {
        console.error("[MSAL Mobile] Error al limpiar localStorage/sessionStorage:", e);
    }
};

export const clearMsalInteractionCache = () => {
    console.log("[MSAL Mobile] Limpiando claves de interacción temporal de MSAL.");
    try {
        const tempKeys = ["interaction.status", "request.state", "temporary", "msal.interaction.status"];
        
        for (let i = sessionStorage.length - 1; i >= 0; i--) {
            const key = sessionStorage.key(i);
            if (key && (tempKeys.some(tk => key.includes(tk)) || (key.startsWith("msal.") && !key.includes("account") && !key.includes("idtoken") && !key.includes("accesstoken")))) {
                sessionStorage.removeItem(key);
            }
        }
        
        for (let i = localStorage.length - 1; i >= 0; i--) {
            const key = localStorage.key(i);
            if (key && (tempKeys.some(tk => key.includes(tk)) || (key.startsWith("msal.") && !key.includes("account") && !key.includes("idtoken") && !key.includes("accesstoken")))) {
                localStorage.removeItem(key);
            }
        }
    } catch (e) {
        console.error("[MSAL Mobile] Error al limpiar caché de interacción de MSAL:", e);
    }
};

export class CustomNavigationClient extends NavigationClient {
    async navigateExternal(url: string, options: NavigationOptions) {
        if (Capacitor.isNativePlatform()) {
            await Browser.open({ url });
            return true;
        } else {
            return super.navigateExternal(url, options);
        }
    }
}
